export default "__VITE_ASSET__CRJyq$l1__";